import { Search } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import AlertModal from 'molecules/AlertModal';
import ButtonGroup from 'molecules/ButtonGroup';
import DataRow from 'molecules/DataRow';
import Drawer from 'molecules/Drawer';
import Empty from 'molecules/Empty';
import SearchableSelect from 'molecules/SearchableSelect';
import Toast from 'molecules/Toast';

import { useState } from 'react';

function GuestRM({ onClose, searchSubmitted, show, addedRM = [], onCancel, name = 'John',
    control, register, onSearch, valueChanged, searchValue, }) {
    if (!show) return null;
    const [showDialog, setShowDialog] = useState('');
    const [addNewGuest, setaddNewGuest] = useState(false);
    const [SelectedGuest, setSelectedGuest] = useState(false);
    const [SelectedGuestadded, setSelectedGuestadded] = useState(false)
    const [toast, setToast] = useState({ show: false, message: "" });
    const addedGuestRm = [
        {
            userpic: "/images/avatar.svg",
            name: "Ram Manohar",
            designation: "Deputy manager ",
            position: "Business operations ",
            category: "Operation transformation",
            Subcategory: "Gps advice",
            empID: "EM0102023"
        },
        {
            userpic: "/images/avatar.svg",
            name: "Ram Manohar",
            designation: "Deputy manager ",
            position: "Business operations ",
            category: "Operation transformation",
            Subcategory: "Gps advice",
            empID: "EM0102023"
        }
    ]
    const Subservices = [
        {
            label: 'AWS',
            value: 'AWS'
        },
        {
            label: 'Strategy and architecture',
            value: 'Strategy and architecture'
        },
        {
            label: 'Engineering',
            value: 'Engineering'
        },
    ]
    const addsuccessfully = () => {
        setToast({ show: true, message: "Guest RM added successfully " });
    }
    const revokeaccess = () => {
        setToast({ show: true, message: "Guest RM revoked successfully" });
    }

    const buttons = [
        {
            label: 'Cancel',
            kind: 'silent',
            onClick: onCancel,
            size: 'l'
        },
        {
            label: 'Give access',
            kind: 'primaryLoud',
            onClick: () => {
                setShowDialog('give-access')
                setSelectedGuestadded(true)
            },
            size: 'l'
        }
    ];

    return (
        <Drawer
            show={true}
            title={addNewGuest ? 'Add Guest RM' : 'Guest RMs'}
            isFooter={false}
            onClose={onClose}
        >
            {addedRM?.length > 0 ? (
                <>
                    <DataRow DataRow={addedRM} Isbutton={true} onClick={() => setShowDialog(revokeaccess)} Buttonlabel='Revoke Access' />
                    {toast.show && <Toast show={true} message={toast.message} />}
                </>
            ) : (
                <>
                    {addNewGuest ? (
                        <>

                            {SelectedGuest ? (
                                <>
                                    {SelectedGuestadded ? (
                                        <>
                                            <SearchableSelect
                                                control={control}
                                                register={register}
                                                name={'resourceName'}
                                                label='Search resource'
                                                placeholder='Search for a resource'
                                                options={Subservices}
                                                isMulti={true}
                                            />
                                        </>
                                    ) : <>
                                        <DataRow DataRow={addedGuestRm} Islinebutton={true} onClick={() => { setSelectedGuest(false) }} />
                                        <div className="fixed bottom-0 bg-white z-50 right-0 p-4 md:p-6 flex justify-end gap-2">
                                            <ButtonGroup buttons={buttons} />
                                        </div>
                                    </>
                                    }
                                </>
                            ) :
                                <>
                                    <Text className='mb-1' color='text-gray-600'> Choose an employee to give access as RM </Text>
                                    <Search
                                        icon="search__s__stroke"
                                        placeholder="Search for an employee"
                                        size="l"
                                        className=''
                                        searchSubmitted={searchSubmitted}
                                        valueChanged={valueChanged}
                                    />
                                    <DataRow DataRow={addedGuestRm} Buttonlabel='Select' Isbutton={true} onClick={() => { setSelectedGuest(true) }} />
                                </>
                            }

                        </>
                    ) : <Empty message='No guest RM added' description='Choose employee to give access as RM'
                        ctaLabel='Add Guest RM' onClick={() => { setaddNewGuest(true) }} />
                    }
                </>
            )
            }

            <AlertModal
                title="Give access to Guest RM"
                show={showDialog === 'give-access'}
                saveLabel="Give access"
                description={`Are you sure want to give access to ${name} as Guest RM?`}
                onClose={onClose}
                onSave={() => setShowDialog(addsuccessfully
                )}
            />
            {toast.show && <Toast show={true} message={toast.message} onClose={() => setToast({ show: false })} />}


        </Drawer >
    )
}

export default GuestRM;